import { useContext } from "react";
import { TooltipContext, TooltipContextValue } from "./TooltipContext";

/**
 * Gets the tooltip context value.
 * @returns The tooltip context value.
 */
export function useTooltipContext(): TooltipContextValue {
  return useContext(TooltipContext);
}
